/**
 * Environment-aware public URL helper for marketing/storefront/share links.
 *
 * Resolution order:
 *  1. REACT_APP_PUBLIC_URL (explicit override — set this in production)
 *  2. window.location.origin (works for same-origin deploys like ashraai.com)
 *  3. "https://ashraai.com" final fallback (must never display in production)
 *
 * Never hardcode ashra.ai or any preview URL. Always go through this helper.
 */

const ENV_URL = (process.env.REACT_APP_PUBLIC_URL || "").replace(/\/$/, "");

export function publicOrigin() {
  if (ENV_URL) return ENV_URL;
  if (typeof window !== "undefined" && window.location?.origin) {
    const o = window.location.origin;
    // If we're on the api.* or app.* subdomain, prefer the bare marketing host.
    if (/^https?:\/\/(app|api|admin|cx)\./.test(o)) {
      return o.replace(/^https?:\/\/(app|api|admin|cx)\./, "https://");
    }
    return o;
  }
  return "https://ashraai.com";
}

/** Build a public URL: storefront, landing-page, referral, share. */
export function publicUrl(path = "") {
  const base = publicOrigin().replace(/\/$/, "");
  const clean = String(path || "").replace(/^\//, "");
  return clean ? `${base}/${clean}` : base;
}

/** Convenience: storefront slug → `https://ashraai.com/p/<slug>` */
export function storefrontUrl(slug) {
  return publicUrl(`p/${slug}`);
}

/** Convenience: hub handle → `https://ashraai.com/<handle>` */
export function hubUrl(handle) {
  return publicUrl(handle || "");
}
